export default {
  data(){
    return {
      delays: { }
    }
  },
  methods: {
    delay(key, callback, ms, ...args){
      if(this.delays[key]) {
        clearTimeout(this.delays[key]);
      }
      this.delays[key] = setTimeout(
        (args) => {
          try {
            args[0](...args[3]);
          } catch(ex) {
            console.error(ex);
          } finally {
            args[1][args[2]] = undefined;
          }
        },
        ms,
        [callback, this.delays, key, args]);
    },
    clearDelay(key) {
      if(this.delays[key]) {
        clearTimeout(this.delays[key]);
        this.delays[key] = undefined;
      }
    },
    clearAllDelays() {
      Object
        .values(this.delays)
        .forEach(clearTimeout)
      
      this.delays = { };
    },
  }
};
